<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8OrUeD/media/FC-9781035836215.jpg?1733711420641" alt="This image is the cover for the book When a Judge's Daughter Is Taken"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When a Judge's Daughter Is Taken
      </h1>
      <p class="bookDescription body article font2">
        <p>A judge must control his courtroom, and Ray is no exception. To maintain order, he leaves emotion at the door, remaining stern and unfaltering. But his family is his only weakness, a vulnerability he fiercely protects – until the unthinkable happens. His daughter is kidnapped. The kidnappers aren’t after money; they demand that Ray keep someone out of jail. Yet, they refuse to reveal who. To ensure their anonymity, they instruct Ray to give everyone remanded in custody a light sentence for one day, two days from now. With his daughter’s life hanging in the balance, Ray faces an agonizing dilemma. Can he trust the kidnappers to release her? His experience tells him that criminals will stop at nothing to get what they want, often leaving a trail of destruction. Ray must continue his duties as if nothing is amiss, knowing someone is watching his every move. Struggling with the moral implications of potentially freeing a dangerous criminal, he searches desperately for any clue that might lead him to those responsible. Every action he takes now will determine his daughter’s fate.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Penelope B
      </h2>
      
      <p class="authorDescription body article">Growing up in New Zealand, Penelope was inspired by her Nana, a well-published author and storyteller. From a young age, her Nana taught her to write down the feelings she found difficult to express. Her first published book, To My Lost Son, shares the journey of a grieving mother, from devastation to acceptance, through poetry. Her passion has always been in fast-paced thrillers. Meet the characters and share in their lives in Penelope's first mystery thriller. Follow Penelope on Facebook to find out about her future books first. https://www.facebook.com/profile.php?id=61557171111148&mibextid=ZbWKwL</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4beed5dc